import React, { useCallback, useEffect, useState } from "react";
import { BryntumSlideToggle } from "@bryntum/core-react-thin";
import { getBoardsConfigurePanelValues, updateBoardsConfigurePanelLocalStorage } from ".";
import { useI18nContext } from "@procore/core-react";
import { BOARDS_CONFIGURE_PANEL_UPDATE_EVENT } from "../utils";

export default function TagsSlideToggleSet() {
   const I18n = useI18nContext();
   const [showTags, setShowTags] = useState(getBoardsConfigurePanelValues().showTags);
   const [showAllTags, setShowAllTags] = useState(getBoardsConfigurePanelValues().showAllTags);

   const syncFromLocalStorage = useCallback(() => {
      const config = getBoardsConfigurePanelValues();
      setShowTags(config.showTags);
      setShowAllTags(config.showAllTags);
   }, []);

   useEffect(() => {
      window.addEventListener(BOARDS_CONFIGURE_PANEL_UPDATE_EVENT, syncFromLocalStorage);
      return () => {
         window.removeEventListener(BOARDS_CONFIGURE_PANEL_UPDATE_EVENT, syncFromLocalStorage);
      };
   }, [syncFromLocalStorage]);

   return (
      <div>
         <div style={{ display: "flex", alignItems: "center" }}>
            <BryntumSlideToggle
               data-testid="show-tags-toggle"
               checked={showTags}
               onChange={({ value }: any) => {
                  updateBoardsConfigurePanelLocalStorage("showTags", value);
                  setShowTags(value);
               }}
            />
            <span style={{ marginInlineStart: "0.3em", fontSize: "0.9em" }}>
               {I18n.t("views.company.workforce_planning.boards.configure_panel.tags")}
            </span>
         </div>
         {showTags && (
            <div style={{ display: "flex", alignItems: "center" }}>
               <BryntumSlideToggle
                  data-testid="show-all-tags-toggle"
                  checked={showAllTags}
                  onChange={({ value }: any) => {
                     updateBoardsConfigurePanelLocalStorage("showAllTags", value);
                     setShowAllTags(value);
                  }}
               />
               <span style={{ marginInlineStart: "0.3em", fontSize: "0.9em" }}>
                  {I18n.t(
                     "views.company.workforce_planning.boards.configure_panel.display_all_tags_on_default",
                  )}
               </span>
            </div>
         )}
      </div>
   );
}
